<template>
  <div>
    <router-view></router-view>
    <div v-if="labelSettings || userSettings" class="m-t-xl d-f fd-c ai-c">
      
      <!-- Reviewers -->
      <!-- <div v-if="userType === 'label'" class="d-f g ai-c">
        <div
          v-for="(key, i) in Object.keys(labelSettings.reviewers ?? {})"
          :key="i"
          class="b-r-100 border p-sm reviewer-image custom-btn"
          :class="{
            'b-brand':
              selectedReviewer?.name === labelSettings.reviewers[key].name,
          }"
          @click.prevent="
            $store.dispatch('setSelectedReviewer', {
              ...labelSettings.reviewers[key],
              id: key,
            })
          "
        >
          <ImageWithInitials
            :src="labelSettings.reviewers[key].profileImage"
            :name="labelSettings.reviewers[key].name"
            size="50"
          />
        </div>
        <p
          class="b-r-100 border p-sm reviewer-image d-f ai-c jc-c custom-btn link"
          @click.prevent="addReviewer"
        >
          <span class="border dashed b-r-100 p d-f ai-c jc-c bs-bb w-100 h-100">
            <IconBase :w="16" :h="16" view-box="0 0 16 16">
              <IconAddPerson />
            </IconBase>
          </span>
        </p>
      </div> -->

      <!-- Old big card tabs -->
      <!-- <div class="hl-tabs-wrap d-f g w-100 m-t-lg">
        <div
          v-for="tab in tabs.filter((t) => !t.showOnSmallTabsOnly)"
          :key="tab.text"
          class="hl-tab d-f fd-c p-lg fd-cp border tt-up flex-1 custom-btn"
          :class="listType === tab.text ? 'card-bg' : 'bc-t'"
          @click="listType = tab.text"
        >
          <div class="d-f ai-c">
            <p class="mute flex-1">{{ tab.text }}</p>
            <IconBase :w="16" :h="16" view-box="0 0 16 16">
              <component :is="tab.icon" />
            </IconBase>
          </div>
          <h2 class="m-0">{{ tab.newCount }} New</h2>
          <p><span class="mute">Total</span>&nbsp;{{ tab.totalCount }}</p>
        </div>
      </div> -->

      <!-- Sent / Received tabs -->
      <h2 class="inbox-tabs-container d-f w-100 jc-c ai-c m-t-lg m-b-lg p-hor bs-bb">
        <div
          class="inbox-view-tab tt-up d-f ai-c m-r"
          :class="{ selected: artistInboxView === 'received', mute: artistInboxView !== 'received' }"
          @click="switchInboxView('received')"
        >
          <span>Incoming</span>
          <span class="mute">&nbsp;{{ receivedDemos?.length || 0 }}</span>
        </div>
        <div 
        class="d-f ai-c"
        style="margin-right: -2px;"
        v-if="artistInboxView === 'received'"
        >
          <IconBase color="#494949" :w="15" :h="15" view-box="0 0 15 15">
            <IconArrowLeft />
          </IconBase>
        </div>
        <div class="line w-100 "></div>
        <div 
        class="d-f ai-c"
        style="margin-left: -2px;"
        v-if="artistInboxView === 'sent'"
        >
          <IconBase color="#494949" :w="15" :h="15" view-box="0 0 15 15">
            <IconArrowRight />
          </IconBase>
        </div>
        <div
          class="inbox-view-tab tt-up d-f ai-c m-l"
          :class="{ selected: artistInboxView === 'sent', mute: artistInboxView !== 'sent' }"
          @click="switchInboxView('sent')"
        >
          <span class="mute">{{ demos?.length || 0 }}&nbsp;</span>
          <span>Outgoing</span>
        </div>
      </h2>

      <div class="tabs-container full-width-tabs d-f w-100 p-hor bs-bb m-t">
        <div class="d-f w-100 b-bottom g jc-c">
        <div
          v-for="tab in tabs"
          :key="tab.text"
          class="tab tt-up"
          :class="{
            selected: listType === tab.text,
            mute: listType !== tab.text,
          }"
          @click="listType = tab.text"
        >
          <span>{{ tab.text }}</span>
          <span class="white">{{
            tab.newCount > 0 ? ` ${tab.newCount}` : ""
          }}</span>
          <span class="mute">{{
            tab.totalCount > 0 ? ` /${tab.totalCount}` : ""
          }}</span>
        </div>

        <!-- <div class="flex-1 d-f jc-fe tt-up">
          <div v-if="listType !== getInboxTabs.Messages" class="d-f fd-r ai-c">
            <select id="sort" class="tt-up pointer" v-model="sortBy">
              <option v-for="o in getSortByOptions" :value="o.value">
                {{ o.text }}
              </option>
            </select>
            <IconBase :w="15" :h="15" view-box="0 0 15 15">
              <IconChevronDown />
            </IconBase>
          </div>
        </div> -->

        </div>

      </div>

      <div class="m-t w-100">
        <DemoTile
          v-for="(demo, i) in sortedDemosList"
          :key="demo.id"
          :demo="demo"
          :show-message="listType === getInboxTabs.Messages"
          ref="demoTile"
          :allSongsPlaylist="sortedDemosPlaylist"
          :playerTrackId="i"
          @click="openDemoReview(demo.id, $event)"
          @played="handleDemoTilePlayed(demo.id)"
          @open-chat="handleDemoChatOpen(demo.id)"
        />

        <div v-if="sortedDemosList.length === 0" class="empty-list p bs-bb">
          <p>List is empty</p>
        </div>
      </div>
    </div>
    <Loader v-else class="pos-center" />
    
    <DemoSubmissionSuccess :testing="false" />

    <ChatSidebar
      :key="chatOpenFor"
      :open="chatOpenFor !== null"
      :demo-id="chatOpenFor"
      @closed="chatOpenFor = null"
    />
    <SelectReviewer />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Loader from "@/components/misc/Loader.vue";
import IconBase from "@/assets/icons/IconBase.vue";
import IconAddPerson from "@/assets/icons/IconAddPerson.vue";
import IconMessage from "@/assets/icons/IconMessage.vue";
import IconStar from "@/assets/icons/IconStar.vue";
import IconHeart from "@/assets/icons/IconHeart.vue";
import IconChevronDown from "@/assets/icons/IconChevronDown.vue";
import PlaceholderImg from "@/assets/icons/PlaceholderImg.vue";
import SelectReviewer from "@/components/labels/SelectReviewer.vue";
import ImageWithInitials from "@/components/misc/ImageWithInitials.vue";
import DemoTile from "@/components/demos/DemoTile.vue";
import ChatSidebar from "@/components/demos/ChatSidebar.vue";
import DemoSubmissionSuccess from "@/components/demos/DemoSubmissionSuccess.vue";
import IconArrowRight from "@/assets/icons/IconArrowRight.vue";
import IconArrowLeft from "@/assets/icons/IconArrowLeft.vue";

export default {
  name: "Inbox",
  components: {
    DemoSubmissionSuccess,
    ChatSidebar,
    DemoTile,
    ImageWithInitials,
    SelectReviewer,
    PlaceholderImg,
    IconChevronDown,
    IconAddPerson,
    IconBase,
    IconArrowRight,
    IconArrowLeft,
    Loader,
  },
  data() {
    return {
      chatOpenFor: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      console.log("init inbox");

      this.listType = this.$route.query.list || this.getInboxTabs.All;
      this.sortBy = this.$route.query.sortBy || "latest";
    },
    addReviewer() {
      this.$router.push({
        name: "Settings",
        query: { tabIndex: 2 },
      });
    },
    switchInboxView(view) {
      this.$store.dispatch("setArtistInboxView", view);
    },
    loadUsersData() {
      const demosList = [...this.demos, ...this.receivedDemos];
      demosList.forEach((demo) => {
        this.$store.dispatch("cacheUserData", {
          uid: demo.submittedTo,
        });
        this.$store.dispatch("cacheUserData", { uid: demo.submittedBy });
      });
    },
    openDemoReview(id, options) {
      if (this.isReceiver && this.userType === "label" && !this.selectedReviewer) {
        alert("Please select a reviewer first.");
        return;
      }

      const pushProps = {
        name: "Demo",
        query: {
          sortBy: this.sortBy,
          list: this.listType,
        },
        params: { id },
      };

      if (options?.openMessages) {
        pushProps.query.openMessages = true;
      }

      this.$router.push(pushProps);
    },
    handleDemoTilePlayed(demoId) {
      this.$refs.demoTile.forEach((ref) => {
        if (ref.$vnode.key === demoId) return;

        ref.pausePlayer();
      });
    },
    handleDemoChatOpen(demoId) {
      this.chatOpenFor = demoId;
    },
  },
  computed: {
    ...mapState([
      "labelSettings",
      "userSettings",
      "demos",
      "receivedDemos",
      "artistInboxView",
      "selectedReviewer",
      "userType",
    ]),
    ...mapGetters([
      "getInboxTabs",
      "getSortByOptions",
      "isReceiver",
      "activeDemos",
      "demosWithMessages",
      "demosWithUnreadMessages",
      "savedDemos",
      "rejectedDemos",
      "ratedDemos",
      "sortedDemosList",
      "getProfileNameByUid",
      "getProfileImageByUid",
    ]),

    listType: {
      get() {
        return this.$store.state.selectedInboxTab;
      },

      set(list) {
        this.$store.dispatch("setSelectedInboxTab", {
          list,
          route: this.$route,
          router: this.$router,
        });
      },
    },

    sortBy: {
      get() {
        return this.$store.state.inboxSortBy;
      },

      set(sortBy) {
        this.$store.dispatch("setInboxSortBy", {
          sortBy,
          route: this.$route,
          router: this.$router,
        });
      },
    },

    tabs() {
      return [
        {
          text: this.getInboxTabs.All,
          newCount: this.activeDemos?.length ?? 0,
          showOnSmallTabsOnly: true,
        },
        {
          text: this.getInboxTabs.Messages,
          totalCount: this.demosWithMessages.length,
          newCount: this.demosWithUnreadMessages.length,
          icon: IconMessage,
        },
        {
          text: this.getInboxTabs.Saved,
          newCount: this.savedDemos.length,
          icon: IconHeart,
        },
        {
          text: this.getInboxTabs.Rated,
          newCount: this.ratedDemos.length,
          icon: IconStar,
        },
        {
          text: this.getInboxTabs.Rejected,
          newCount: this.rejectedDemos.length,
          showOnSmallTabsOnly: true,
        },
      ];
    },

    sortedDemosPlaylist() {
      return this.sortedDemosList.map((demo, i) => {
        const genres = demo.genre ? { gen0: demo.genre } : {};

        return {
          album: this.listType,
          artist: this.getProfileNameByUid(demo.submittedBy),
          cover: this.getProfileImageByUid(demo.submittedBy),
          audio: demo.url,
          genres,
          rankTotal: i + 1,
          songUid: demo.id,
          title: demo.title,
          userUid: demo.submittedBy,
        };
      });
    },
  },
  watch: {
    labelSettings() {},
    userSettings() {},
    userType() {},
    demos() {
      this.loadUsersData();
    },
    receivedDemos() {
      this.loadUsersData();
    },
    selectedReviewer() {},

    $route() {
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";

.reviewer-image {
  width: 50px;
  height: 50px;
}

.hl-tabs-wrap {
  width: 100%;
  overflow: scroll;
  .hl-tab {
    min-width: 160px !important;
  }
}

#sort {
  appearance: none;
  background-color: transparent;
  border: none;
  font-family: $font;
  font-size: $p1;
  color: $text-color;
  box-sizing: border-box;
  outline: none;
  cursor: pointer;
  display: inline-block;
  &:hover {
    text-decoration: underline;
  }
}

.inbox-tabs-container {
  height: 20vh;
  .line {
    height: 1px;
    background-color: $line-color;
  }
}

.inbox-view-tab {
  cursor: pointer;
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
  &.selected {
    color: $white;
  }
}

// .demo-img {
//   width: 130px;
//   height: 130px;
//   img {
//     width: 100% !important;
//     height: 100% !important;
//   }
// }
</style>
